import * as React from 'react';
import classNames from 'clsx';

import { INFRASTRUCTURE_MAP_ICON_MAP, INFRASTRUCTURE_MAP_SQUARE_ICON } from '../../constants/infrastructure';
import { TInfrastructureType } from '../../types/map';
import { IMainPromoPin } from '../../types/newbuilding/mainPromoPin';
import { SpecialPromoPin } from './SpecialPromoPin';
import * as styles from './styles.css';

export interface IMapPinProps {
  type: TInfrastructureType;
  mainPromoPin?: IMainPromoPin | null;
  color?: 'blue' | 'green';
}

export function MapPin({ type, mainPromoPin, color = 'blue' }: IMapPinProps) {
  const Icon = INFRASTRUCTURE_MAP_ICON_MAP.get(type);
  const squareIcon = INFRASTRUCTURE_MAP_SQUARE_ICON.includes(type);

  if (mainPromoPin) {
    return <SpecialPromoPin backgroundColor={mainPromoPin.backgroundColor} imageUrl={mainPromoPin.logo} />;
  }

  if (type === 'main') {
    return <div className={styles['pin-main']} />;
  }

  if (!Icon) {
    return null;
  }

  return (
    <div
      className={classNames(styles['pin'], styles[color], squareIcon && styles['pin-square'])}
      data-testid={`MapPin-${type}`}
    >
      <Icon color={'white_100'} />
    </div>
  );
}
